import { Tag, TopicType } from '../../../../ontology.model';

export const geometricTags: Tag[] = [
  {
    id: 'tag.geo',
    name: 'Geometric',
    parent_id: 'tag.seq',
    topic_type: TopicType.Generative,
    icon: 'shapes',
    description: 'Sequences with a constant common ratio.',
    verification: [{ reviewer: 'Hung Dang', status: 'verified', date: '2025-12-01' }],
  },
  {
    id: 'tag.geo.seq',
    name: 'Sequence',
    parent_id: 'tag.geo',
    icon: 'list-ol',
    description: 'Properties related to the terms ($u_n$).',
    verification: [{ reviewer: 'Hung Dang', status: 'verified', date: '2025-12-01' }],
  },
  {
    id: 'tag.geo.series',
    name: 'Series',
    parent_id: 'tag.geo',
    icon: 'layer-group',
    description: 'Properties related to the sum of terms ($S_n, S_\\infty$).',
    verification: [{ reviewer: 'Hung Dang', status: 'verified', date: '2025-12-01' }],
  },
];
